import { Stack, Image, ImageFit, Label, PrimaryButton, DefaultButton, FontIcon } from '@fluentui/react';
import React from 'react';
import styles from '../styles/pokemon.module.scss';
import { TProduct } from '../constants/types';

export interface IPokemonCardsProps {
    card: TProduct;
    onBuyClick: Function;
    satprice: number;
    onImageClick: Function;
    animationsEnabled: boolean;
    eurprice: number;
    hideSwipe: boolean;
    addCard: Function;
    removeCard: Function;
    saving: boolean;
}

export interface IPokemonCardsState {
    selectedImageIdex: number;
    rarityStyle: string;
    rarityImgStyle: string;
    rarityImg: string;
    added: boolean;
    notAdded: boolean;
    startSwipe: number;
    endSwipe: number;
    swipeHidden: boolean;
};

export default class PokemonCards extends React.Component<IPokemonCardsProps, IPokemonCardsState> {
    constructor(props: IPokemonCardsProps) {
        super(props);

        this.UpdateComponent = this.UpdateComponent.bind(this);
        this.swipeTimeout = this.swipeTimeout.bind(this);

        this.state = {
            rarityStyle: "",
            rarityImgStyle: "",
            selectedImageIdex: 0,
            rarityImg: "",
            added: false,
            notAdded: false,
            startSwipe: -1,
            endSwipe: -1,
            swipeHidden: this.props.hideSwipe,
        };
    }

    private UpdateComponent() {
        let imageUrls : string[] = [];

        let rarityStyle : string = styles.cardRarity_Common;
        let rarityImg: string = `https://pokemoncollectie.nl/assets/cardtypes/`;
        let rarityImgStyle = styles.rarityImg1;
        switch (this.props.card.rarety) {
            case "Common":
                rarityStyle = styles.cardRarity_Common;
                rarityImg += "common.png";
                break;
            case "Uncommon":
                rarityStyle = styles.cardRarity_Uncommon;
                rarityImg += "uncommon.png";
                break;
            case "Rare":
                rarityStyle = styles.cardRarity_Rare;
                rarityImg += "rare.png";
                break;
            case "Double Rare":
                rarityStyle = styles.cardRarity_DoubleRare;
                rarityImg += "dobule-rare.png";
                break;
            case "Illustration Rare":
                rarityImgStyle = styles.rarityImg2;
                rarityStyle = styles.cardRarity_IllustrationRare;
                rarityImg += "illustration-rare.png";
                break;
            case "Special Illustration Rare":
                rarityImgStyle = styles.rarityImg2;
                rarityStyle = styles.cardRarity_SpecialIllustrationRare;
                rarityImg += "special-illust.png";
                break;
            case "Ultra Rare":
                rarityImgStyle = styles.rarityImg2;
                rarityStyle = styles.cardRarity_UltraRare;
                rarityImg += "ultra-rare.png";
                break;
            case "Promo":
                rarityStyle = styles.cardRarity_Promo;
                rarityImg += "promo.png";
                break;
            default:
                rarityImgStyle = styles.rarityImg2;
                rarityStyle = styles.cardRarity_SpecialIllustrationRare;
                rarityImg += "hyper-rare.png";
                break;
        }

        this.setState( {
            rarityImgStyle: rarityImgStyle,
            rarityImg: rarityImg,
            rarityStyle: rarityStyle,
            selectedImageIdex: 0,
        });
    }

    componentDidMount(): void {
        this.UpdateComponent();
        if (this.props.hideSwipe === false) {
            this.swipeTimeout();
        }
    }

    swipeTimeout() {
        setTimeout(() => {
            this.setState({swipeHidden: true});
                setTimeout(() => {
                    this.setState({swipeHidden: false});
                    this.swipeTimeout();
                }, 60000);
        }, 2000);
    }

    componentDidUpdate(prevProps: Readonly<IPokemonCardsProps>, prevState: Readonly<IPokemonCardsState>, snapshot?: any): void {
        if (prevProps.card.id != this.props.card.id) {
            this.UpdateComponent();
        }
    }

    swipeEnd(e) {
        if (this.state.startSwipe != -1 && this.state.endSwipe != -1) {
            if ((this.state.endSwipe - this.state.startSwipe) > 20) {
                this.state.selectedImageIdex > 0 ? this.setState({selectedImageIdex : this.state.selectedImageIdex-1}) : this.setState({selectedImageIdex : this.props.card.imageUrls.length -1});
            } else if ((this.state.startSwipe - this.state.endSwipe) > 20) {
                this.state.selectedImageIdex+1 < this.props.card.imageUrls.length ? this.setState({selectedImageIdex : this.state.selectedImageIdex+1}) : this.setState({selectedImageIdex : 0});
            }
            this.setState({startSwipe: -1, endSwipe: -1});
        }
    }

    public render(): React.ReactElement<IPokemonCardsProps> {
        const card = this.props.card;
        let shimmerStyle = "";
        if (this.props.animationsEnabled && card.rarety !== "Common" && card.rarety !== "Uncommon") {
            const r = Math.floor(Math.random() * 4);
            shimmerStyle = styles[`cardshimmer${r}`]
        }
        return (
            <Stack className={styles.card}>
                <Stack>
                    <Stack horizontal>
                        <div className={`${styles.cardTitleContainer} ${this.state.rarityStyle}`}>
                            <Stack horizontal horizontalAlign='space-between'>
                                <Stack horizontal horizontalAlign='start'>
                                    <div className={styles.cardTitle}>
                                        {card.title}
                                    </div>
                                </Stack>
                            </Stack>
                        </div>
                    </Stack>
                    <Stack horizontal verticalAlign='center' horizontalAlign='center' style={{overflow:"hidden"}} onClick={ () => {this.props.onImageClick(card.imageUrls[this.state.selectedImageIdex]); }}>
                        <div className={`${styles.cardshine} ${styles.cardCompImg}`}>
                            <Image {...{imageFit: ImageFit.centerContain,
                                        className: styles.cardCompImg,
                                        src: card.imageUrls[this.state.selectedImageIdex],
                                        onTouchStart: (e) => { this.setState({startSwipe: e.targetTouches[0].clientX}); },
                                        onTouchMove: (e) => { this.setState({endSwipe: e.targetTouches[0].clientX}); },
                                        onTouchEnd: this.swipeEnd.bind(this),
                                        onError: ( e ) => { e.currentTarget.onerror = null;
                                                            e.currentTarget.src=`https://pokemoncollectie.nl/assets/pokemon/cardback.png`},
                                        styles: props => ({ root: { margin: 0, cursor: "pointer", backgroundColor: "transparent" } }),
                                    }} alt="" />
                            <div className={shimmerStyle}></div>
                        </div>
                    </Stack>
                    <Stack horizontalAlign='center' horizontal>
                        <FontIcon aria-label="Volgende" className={styles.prevNextIcon} onClick={() => {this.state.selectedImageIdex > 0 ? this.setState({selectedImageIdex : this.state.selectedImageIdex-1}) : this.setState({selectedImageIdex : card.imageUrls.length -1})}} iconName="ChevronLeft" />
                        {this.state.selectedImageIdex+1} / {card.imageUrls.length} 
                        <FontIcon aria-label="Volgende" className={styles.prevNextIcon} onClick={() => {this.state.selectedImageIdex+1 < card.imageUrls.length ? this.setState({selectedImageIdex : this.state.selectedImageIdex+1}) : this.setState({selectedImageIdex : 0})}} iconName="ChevronRight" />
                    </Stack>
                    <Stack className={styles.cardInfo}>
                        <Stack horizontal>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>{card.title}</Label>
                            </Stack>
                        </Stack>
                        <Stack horizontal>
                            <Stack horizontal horizontalAlign='start' style={{maxWidth:"100%", display:"inline-block"}}>
                                <Label className={styles.rarityLabel}>{card.rarety}</Label>
                            </Stack>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>{card.scardnumber}/{card.size}</Label>
                            </Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>Versie :</Label>
                            </Stack>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>{card.version}</Label>
                            </Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>ID :</Label>
                            </Stack>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>{card.id}</Label>
                            </Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>Set :</Label>
                            </Stack>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>{card.name}</Label>
                            </Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>USD :</Label>
                            </Stack>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>{card.priceInUSD}</Label>
                            </Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>EUR :</Label>
                            </Stack>
                            <Stack horizontal horizontalAlign='end'>
                                <Label>{card.priceInEUR}</Label>
                            </Stack>
                        </Stack>
                         
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontalAlign='start'>
                                {this.props.addCard == null ? 
                                    <Label><h2>Aantal : </h2></Label>
                                :
                                    <Label><b>Beschikbaar : </b></Label>}
                            </Stack>
                            <Stack horizontalAlign='start'>
                                {this.props.addCard == null ? 
                                        <Label><h2>{card.available}</h2></Label>
                                    :
                                        <Label><b>{card.available}</b></Label>}
                                
                            </Stack>
                        </Stack>
                        
                        
                        {this.props.addCard != null && <Stack horizontal horizontalAlign='space-between'>
                            <PrimaryButton disabled={this.props.saving} text="-" onClick={() => {this.props.removeCard(this.props.card); }}/>
                            <PrimaryButton disabled={this.props.saving} text="+" onClick={() => {this.props.addCard(this.props.card); }}/>
                        </Stack>}
                    </Stack>
                </Stack>
            </Stack> 
        );
    }
}